import { Component, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy, Inject } from '@angular/core';
import { APP_ICONS } from '../../icons/app-icons';
import { Location } from '@angular/common';
import { ClientRegisterFormComponent } from '../client-register-form/client-register-form.component';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AuthService } from '@abp/ng.core';
import { SelectedSommelierService } from '../../services/selected-sommelier.service';
import { ModalCommunicationService } from '../../services/modal-communication.service';


interface Client {
  name: string;
  email: string;
  phone: string;
  address: string;
}

@Component({
  selector: 'app-metro-public-header',
  templateUrl: './metro-public-header.component.html',
  standalone: false,
  host: {
    '[style.display]': 'hideHeader ? "none" : "block"'
  }
})
export class MetroPublicHeaderComponent implements OnInit, OnDestroy {
  @Input() title: string = '';
  @Input() logoSrc = 'assets/images/logo/logo-landscape.png';
  @Input() showBack: boolean = true;
  @Input() showLoginButton: boolean = false;
  @Output() back = new EventEmitter<void>();
  @Output() loginClick = new EventEmitter<void>();

  @ViewChild(ClientRegisterFormComponent) clientRegisterForm?: ClientRegisterFormComponent;

  showRegisterClientModal = false;
  iconBack = APP_ICONS.arrow;
  iconGoogle = APP_ICONS.google;
  canGoBack = false;
  hideHeader = false;
  isDarkMode = false; // Default to light mode
  private routerSubscription?: Subscription;
  sommelierSlug!: string;
  showRegisterButton = false;
  registerStep: 'options' | 'form' = 'options';


  constructor(
    private location: Location,
    private router: Router,
    private authService: AuthService,
    private slugService: SelectedSommelierService,
    private modalCommunicationService: ModalCommunicationService
  ) {
    // Set initial theme based on current URL
    const currentUrl = window.location.pathname;
    const isLoggedIn = this.authService.isAuthenticated;
  }

  ngOnInit() {
    this.canGoBack = window.history.length > 1;
    // Set initial theme based on URL and auth state
    this.checkRoute(this.router.url);
    // Subscribe to router events to detect route changes
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.checkRoute(event.url);
      });

    this.slugService.getSlug$().subscribe(slug => {
      this.sommelierSlug = slug;
    });
    this.modalCommunicationService.openRegisterModal$.subscribe(shouldOpen => {
      if (shouldOpen) {
        this.openModalRegister();
        setTimeout(() => {
          this.modalCommunicationService.resetModalTrigger();
        }, 0);
      }
    });
  }

  private checkRoute(url: string): void {
    const publicRoutes = [
      '/account/login',
      '/account/confirm-email',
      '/account/forgot-password'
    ];

    const cleanUrl = url.split('#')[0].split('?')[0];
    const isHomePage = cleanUrl === '/' || cleanUrl === '';
    this.hideHeader = isHomePage || publicRoutes.some(route => cleanUrl.startsWith(route));

    const catalogRegex = /^\/[^\/]+\/catalog(\/wine\/[^\/]+)?$/;
    const profileRegex = /^\/[^\/]+$/;

    this.showRegisterButton = catalogRegex.test(url) || profileRegex.test(url);

    this.isDarkMode = false;
    this.logoSrc = 'assets/images/logo/logo-landscape.png';
  }


  onBackClick() {
    this.back.emit();
    this.location.back();
  }

  goToHome() {
    this.router.navigate(['/']);
  }

  login() {
    this.authService.navigateToLogin();
  }

  openModalRegister(): void {
    this.registerStep = 'options';
    this.showRegisterClientModal = true;
  }

  onModalConfirm() {
  if (this.clientRegisterForm?.form.valid) {
    this.clientRegisterForm.onSubmit();
  } else {
    console.warn("Formulario inválido, el modal sigue abierto");
  }
}

  onClientSubmit(client: Client): void {
    this.showRegisterClientModal = false;
  }

  onClientCancel(): void {
    this.showRegisterClientModal = false;
  }


  handleClientSaved() {
  this.showRegisterClientModal = false;
  this.router.navigate(['/account/login']);
}

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

}
